import React from 'react';
import { IconInfo, Typography } from '@screentone/core';

import { PreferredTimezone } from 'data/generated/graphql';
import { AllessehContent } from 'hooks/useAllessehContentQuery';
import { formatInTimeZone } from 'utils/dates';
import styles from './EmbargoWarning.module.scss';

interface EmbargoWarningProps {
  embargoInfo?: AllessehContent;
  preferredTimezone?: PreferredTimezone;
  dataTestId?: string;
}

const EmbargoWarning = ({
  embargoInfo,
  preferredTimezone,
  dataTestId
}: EmbargoWarningProps): React.ReactElement | null => {
  if (!preferredTimezone || !embargoInfo) {
    return null;
  }

  const { embargo_datetime_utc: embargoDatetimeUtc = null } = embargoInfo.data.attributes;
  let embargoLabel = '';

  if (!embargoDatetimeUtc) {
    embargoLabel = `Invalid embargo date for article: ${embargoInfo.data.id}`;
    console.warn('EmbargoWarning: embargo_datetime_utc is missing for content', embargoInfo);
  } else {
    const embargoTimestamp = new Date(embargoDatetimeUtc).getTime();

    embargoLabel = `Embargoed story for ${formatInTimeZone(
      embargoTimestamp,
      preferredTimezone,
      "M/dd/yyyy 'at' hh:mm aaaa",
      { showTimezoneAbbreviation: true }
    )}`;
  }

  return (
    <div className={styles.embargoWarning}>
      <IconInfo />
      <Typography margin={{ right: 'xs' }} data-testid={dataTestId ?? 'embargo-date-label'}>
        {embargoLabel}
      </Typography>
    </div>
  );
};

export default EmbargoWarning;
